var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 2.91666C10.9597 2.72166 10.808 2.55801 10.621 2.44374C10.4341 2.32946 10.2192 2.269 10.0001 2.269C9.78101 2.269 9.56616 2.32946 9.37922 2.44374C9.19228 2.55801 9.0405 2.72166 8.94059 2.91666L2.39297 16.0119C2.30165 16.1931 2.25817 16.3947 2.26667 16.5974C2.27516 16.8002 2.33534 16.9974 2.4415 17.1704C2.54766 17.3433 2.69627 17.4863 2.87321 17.5856C3.05016 17.685 3.24957 17.7375 3.4525 17.7381H16.5477C16.7507 17.7375 16.9501 17.685 17.127 17.5856C17.304 17.4863 17.4526 17.3433 17.5587 17.1704C17.6649 16.9974 17.7251 16.8002 17.7336 16.5974C17.7421 16.3947 17.6986 16.1931 17.6073 16.0119L11.0596 2.91666Z",
    stroke: "#FFA800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.61905V11.4881",
    stroke: "#FFA800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.7619C9.83589 14.7619 9.70264 14.6287 9.70264 14.4643C9.70264 14.2999 9.83589 14.1667 10.0003 14.1667",
    stroke: "#FFA800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 14.7619C10.1649 14.7619 10.2981 14.6287 10.2981 14.4643C10.2981 14.2999 10.1649 14.1667 10.0005 14.1667",
    stroke: "#FFA800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIcon);
export default __webpack_public_path__ + "static/media/InvalidIcon.84aaea9d21bfc09cfc9d77a63d754578.svg";
export { ForwardRef as ReactComponent };